export default "dist/images/block-number-box-basic.2a2c1ec.png";